import { Component, Input, OnInit, inject } from '@angular/core';

import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { dialogData, genericDialogComponent } from '../genericDialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import {
  MatDialogModule,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { UserService } from 'BaseServices/user-service';
import { dialogInputTitleComponent } from '../../../../../../src/app/elements/dialog-input-title.component';
import { SaveButtonComponent } from '../../../../../../src/app/buttons/save-button/save-button.component';
import { DeleteButtonComponent } from '../../../../../../src/app/buttons/delete-button/delete-button.component';
import {
  AgreementDetailDTO,
  AgreementSummaryDTO,
  ClientSummaryDTO,
  PlantSummaryDTO,
} from 'projects/Assets/src/assets-base/dataTypes';
import { MainService } from 'BaseServices/main-service';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-requsition-number-dialog',
  imports: [
    FormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    dialogInputTitleComponent,
    SaveButtonComponent,
    DeleteButtonComponent,
    MatIconModule,
  ],
  templateUrl: './agreement-dialog.component.html',
  styleUrls: [
    '../../../../../../src/app/general-styles/dialogs.css',
    './agreement-dialog.component.css',
  ],
  providers: [DatePipe],
})
export class AgreementDialogComponent
  extends genericDialogComponent
  implements OnInit
{
  readonly data = inject<dialogData<AgreementDetailDTO[]>>(MAT_DIALOG_DATA);
  @Input() agreementrequest!: AgreementDetailDTO;

  clients: ClientSummaryDTO[] = [];
  plants: PlantSummaryDTO[] = [];
  get shownPlants() {
    return this.plants.filter((p) => {
      if (!this.agreementrequest.clientId || this.agreementrequest.clientId == 0) return true;
      const client = this.clients.find((c) => c.id === this.agreementrequest.clientId);
      if (!client) return false;
      return p.clientName === client.name;
    });
  }
  clientCascade(clientId: number) {
    this.agreementrequest.clientId = clientId;
    this.agreementrequest.plantId = null;
  }

  currentUser = this.userService.currentUser;
  constructor(
    public override dialogRef: MatDialogRef<AgreementDialogComponent>,
    public mainService: MainService,
    public userService: UserService
  ) {
    super(dialogRef);
    this.agreementrequest = this.data.data[0];
  }

  ngOnInit(): void {
    this.mainService.getAll<ClientSummaryDTO>('Client').subscribe((result) => {
      this.clients = result;
    });

    this.mainService.getAll<PlantSummaryDTO>('Plant').subscribe((result) => {
      this.plants = result;
    });
  }
  saveChanges() {
    if (this.agreementrequest.id == 0) {
      this.mainService
        .add<AgreementDetailDTO, AgreementSummaryDTO>(
          'Agreement',
          this.agreementrequest
        )
        .subscribe((result) => {
          this.dialogRef.close(true);
        });
    } else {
      this.mainService
        .update<AgreementDetailDTO, AgreementSummaryDTO>(
          'Agreement',
          this.agreementrequest
        )
        .subscribe((result) => {
          this.dialogRef.close(true);
        });
    }
  }

  deleteEntry() {
    if (!confirm("Er du sikker på at du vil slette aftalen?'")) {
      return;
    }
    this.mainService
      .delete('Agreement', this.agreementrequest.id)
      .subscribe((result) => {
        this.dialogRef.close(true);
      });
  }
}
